export default __webpack_public_path__ + "static/media/pdf-icon.d5eafa7fe8ccac555139fe118f2ead8c.svg";